import type {
  ISendBulkSubscriptionInvitationsBody,
  ISendBulkSubscriptionInvitationsResponse,
} from '@/app-package';
import type { AxiosResponse } from 'axios';
import axios from 'axios';

const sendBulkSupraSystemSubscriptionInvitations = async (
  body: ISendBulkSubscriptionInvitationsBody,
): Promise<ISendBulkSubscriptionInvitationsResponse> => {
  const { data } = await axios.post<
    ISendBulkSubscriptionInvitationsResponse,
    AxiosResponse<ISendBulkSubscriptionInvitationsResponse>,
    ISendBulkSubscriptionInvitationsBody
  >('/supra_system/subscription/send_bulk_invites', body);

  return data;
};

export default sendBulkSupraSystemSubscriptionInvitations;
